import { getCookie } from '@/Util/helpers.js';
import { PARTNER_DISCOUNT, PARTNER_ID } from '@/Util/constants.js';

export default (commit, getters) => {
    const partnerIdCookieVal = getCookie(PARTNER_ID);
    const adPartner = getCookie(PARTNER_DISCOUNT);


    if (!getters.adPartner && !!adPartner) {
        let adPartnerObj = JSON.parse(adPartner);
        commit('updatePurchaseInfo', { sourceCode: adPartnerObj.name });
    }

    if (!getters.partnerAccountId && !!partnerIdCookieVal) {
        let partnerAccountId = partnerIdCookieVal;
        commit('updatePurchaseInfo', { partnerAccountId });
    }
}
